import contentData from "@/src/generated/content.json";
import siteConfig from "@/site.config.json";

export type Download = { title: string; href: string; type: string };
export type CourseDocument = { id: string; title: string; kind: string; summary: string; html: string };
export type CourseVisual = { id: string; week: number; role: string; purpose: string; alt: string; src: string; srcSmall: string; rights: string };
export type Week = {
  number: number;
  slug: string;
  title: string;
  phase: string;
  narrative: string;
  labEvent: string | null;
  presentation: string | null;
  reading: { title: string; html: string } | null;
  deck: { pptx: string; pdf: string; filename: string } | null;
  hero: CourseVisual | null;
  conceptMap: CourseVisual | null;
  docs: CourseDocument[];
  downloads: Download[];
};
export type Lab = {
  number: number;
  slug: string;
  title: string;
  html: string;
  notebook: { href: string; repoPath: string; filename: string } | null;
  docs: CourseDocument[];
  files: Download[];
};

export const content = contentData;
export const config = siteConfig;
export const weeks = content.weeks as Week[];
export const labs = content.labs as Lab[];
export const course = content.courseConfig;
export const visualFor = (week: number, role = "hero") =>
  (content.visuals as CourseVisual[]).find((visual) => visual.week === week && visual.role === role);
